import {
  initPlansSwitcher,
  initPlansSlider,
} from "./components/pricing-plans/index.js";

export class PricingPage {
  constructor(options) {
    this.options = $.extend(
      {
        node: $(".pricing-plans"),
      },
      options
    );

    $(window).on("resize", () => {
      this._initIncludedFeaturesAccordion();
    });

    initPlansSwitcher();
    initPlansSlider();
    this._initIncludedFeaturesAccordion();
    // this._initEnterprisePopup();
  }

  _initIncludedFeaturesAccordion() {
    var width = $(window).width();

    if (width < 768) {
      // add accordion

      $(".plans-include__item .item__content").css("max-height", "0");

      $(".plans-include__item .item__header").on("click", (event) => {
        let $target = $(event.currentTarget);
        let $content = $target.next();

        $target.toggleClass("active");

        if ($content.height() != 0) {
          $content.css("max-height", 0);
          $content.removeClass("expanded");
        } else {
          $content.css("max-height", $content[0].scrollHeight + "px");
          $content.addClass("expanded");
        }

        $(".plans-include__item .item__content")
          .not($content)
          .css("max-height", 0);
        $(".plans-include__item .item__header")
          .not($target)
          .removeClass("active");
        $(".plans-include__item .item__content")
          .not($content)
          .removeClass("expanded");
      });
    } else {
      // remove accordion

      $(".plans-include__item .item__content").css("max-height", "none");
      $(".plans-include__item .item__header").removeClass("active");

      $(".plans-include__item .item__header").off("click");
    }
  }

  // _initEnterprisePopup() {
  //   let $window = $(window);
  //   let $anchor = $(".enterprise-anchor");
  //   let $popup = $(".enterprise-popup");

  //   $(".enterprise-popup__close").click(function () {
  //     $popup.addClass("hidden");
  //   });

  //   let $popupPadding = $anchor.offset().top;
  //   $popup.css("top", $popupPadding);

  //   $(window).scroll(function () {
  //     let $windowHeight = $window.height();
  //     let $windowTopPosition = $window.scrollTop();
  //     let $windowBottomPosition = $windowTopPosition + $windowHeight;

  //     let $anchorHeight = $anchor.outerHeight();
  //     let $anchorTopPosition = $anchor.offset().top;
  //     let $anchorBottomPosition = $anchorTopPosition + $anchorHeight;

  //     if (
  //       $anchorBottomPosition >= $windowTopPosition &&
  //       $anchorTopPosition <= $windowBottomPosition
  //     ) {
  //       $popup.addClass("active");
  //     } else {
  //       $popup.removeClass("active");
  //     }
  //   });
  // }
}

new PricingPage();
